import { render } from "./StandConfigurator.vue?vue&type=template&id=6b611d00&scoped=true"
import script from "./StandConfigurator.vue?vue&type=script&lang=js"
export * from "./StandConfigurator.vue?vue&type=script&lang=js"

import "./StandConfigurator.vue?vue&type=style&index=0&id=6b611d00&scoped=true&lang=css"

import exportComponent from "/Users/diekstra/PhpstormProjects/rbs-vlb-reservations/rvr-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b611d00"]])

export default __exports__